
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#7D7D7D"}},[_c('path',{attrs:{"d":"M.716 15.985l3.722-.834h.031a1.33 1.33 0 00.94-.391L15.603 4.57a1.35 1.35 0 000-1.904L13.335.393a1.35 1.35 0 00-1.905 0L1.23 10.59a1.302 1.302 0 00-.38.956l-.838 3.737a.588.588 0 00.705.705M12.022.984a.512.512 0 01.722 0l2.269 2.272a.499.499 0 01.111.556.513.513 0 01-.111.167l-.983.982-2.994-2.992.986-.985zm-9.926 9.922l8.35-8.348 2.993 2.993-8.35 8.347-2.993-2.992zm-.809 2.53l.395-1.762 2.647 2.646-1.893.423-1.149-1.308z"}}),_c('path',{attrs:{"d":"M4.574 11.839a.409.409 0 01-.294-.123.419.419 0 010-.591l6.355-6.352a.415.415 0 01.714.295c0 .11-.044.217-.122.296L4.87 11.716a.415.415 0 01-.297.123"}})])])
          )
        }
      }
    